import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/crm/clients" });

export const InvoiceService = {
  getAllInvoices: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/invoices?${params.toString()}`);
  },

  getInvoiceById: (id) => {
    return api.get(`/invoices/${id}`);
  },

  createInvoice: (clientId, payload) => {
    return api.post(`/${clientId}/invoices`, payload);
  },

  updateInvoice: (id, payload) => {
    return api.put(`/invoices/${id}`, payload);
  },

  deleteInvoice: (id) => {
    return api.delete(`/invoices/${id}`);
  },
};
